import type { LucideIcon } from 'lucide-react'

interface Props {
  icon: LucideIcon
  label: string
  value: string
}

export const StatTile = ({ icon: Icon, label, value }: Props) => (
  <div className="rounded-3xl bg-foreground/5 p-5 lg:p-6">
    <div className="flex items-center gap-2 text-sm text-muted-foreground">
      <Icon className="size-[18px]" />
      {label}
    </div>
    <div className="mt-3 text-3xl font-semibold leading-none lg:mt-4 lg:text-5xl">{value}</div>
  </div>
)
